import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  reviewsSummaryFailed: {
    id: 'pd.reviews.fail.summary',
    defaultMessage: 'Nepodařilo se načíst souhrn recenzí',
  },
  reviewsFailed: {
    id: 'pd.reviews.fail.reviews',
    defaultMessage: 'Nepodařilo se načíst recenze',
  },
  reviewMotivatedTitle: {
    id: 'pd.reviews.motivated.title',
    defaultMessage: 'Dárek',
  },
  reviewPartnerTitle: {
    id: 'pd.reviews.partner.title',
    defaultMessage: 'Recenze od partnera',
  },
  reviewVerifiedPartnerTitle: {
    id: 'pd.reviews.verifiedPartner.title',
    defaultMessage: 'Ověřená recenze od partnera',
  },
  reviewUnknownTitle: {
    id: 'pd.reviews.unknown.title',
    defaultMessage: 'Neověřená recenze',
  },
  reviewVerifiedTitle: {
    id: 'pd.reviews.verified.title',
    defaultMessage: 'Ověřená recenze',
  },
  reviewMotivatedDescription: {
    id: 'pd.reviews.motivated.description',
    defaultMessage:
      'Recenzovaný produkt od nás dostal autor recenze zdarma jako dárek.',
  },
  reviewUnknownDescription: {
    id: 'pd.reviews.unknown.description',
    defaultMessage:
      'Recenzovaný produkt si u nás autor recenze nekoupil nebo jeho nákup nemůžeme ověřit.',
  },
  reviewVerifiedDescription: {
    id: 'pd.reviews.verified.description',
    defaultMessage:
      'Recenzovaný produkt si u nás autor recenze opravdu koupil.',
  },
  reviewPartnerDescription: {
    id: 'pd.reviews.partner.description',
    defaultMessage: 'Kopie recenze z webu našeho partnera',
  },
  reviewVerifiedPartnerDescription: {
    id: 'pd.reviews.verifiedPartner.description',
    defaultMessage: 'Kopie ověřené recenze z webu našeho partnera',
  },
  reviewMotivatedMoreLink: {
    id: 'pd.reviews.motivated.more.link',
    defaultMessage: 'null',
  },
  reviewUnknownMoreLink: {
    id: 'pd.reviews.unknown.more.link',
    defaultMessage: 'null',
  },
  reviewVerifiedMoreLink: {
    id: 'pd.reviews.verified.more.link',
    defaultMessage: 'null',
  },
  reviewPartnerMoreLink: {
    id: 'pd.reviews.partner.moreLink',
    defaultMessage: '/produktove-recenze',
  },
  reviewVerifiedPartnerMoreLink: {
    id: 'pd.reviews.verifiedPartner.moreLinkn',
    defaultMessage: '/produktove-recenze',
  },
  reviewMoreText: {
    id: 'pd.reviews.verified.more.text',
    defaultMessage: 'Více informací',
  },
  tryAgain: {
    id: 'reviews.send.review.retry',
    defaultMessage: 'Zkusit znovu',
  },
  collectingReviewsText: {
    id: 'pd.reviews.collect.reviews.text',
    defaultMessage: 'Jak sbíráme recenze',
  },
  collectingReviewsLink: {
    id: 'pd.reviews.collect.reviews.link',
    defaultMessage: '/produktove-recenze',
  },
  originallyPublishedOn: {
    id: 'pd.reviews.originallyPublishedOn',
    defaultMessage: 'Původně publikováno na <b>{website}</b>',
  },
  originallyPostedOn: {
    id: 'pd.reviews.originallyPostedOn',
    defaultMessage: 'Původně publikováno na <b>{shopId}</b>',
  },
  showOriginal: {
    id: 'pd.reviews.showOriginal',
    defaultMessage: 'Zobrazit originál',
  },
  showTranslation: {
    id: 'pd.reviews.showTranslation',
    defaultMessage: 'Zobrazit překlad',
  },
  reviewRatingAriaLabel: {
    id: 'pd.reviews.rating.ariaLabel',
    defaultMessage: 'Hodnocení {score} z 5',
  },
  starsSummaryRowAriaLabel: {
    id: 'pd.reviews.starsSummary.row.ariaLabel',
    defaultMessage: 'Hodnocení {stars} z 5, počet hodnocení: {count}',
  },
});
